import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SmallLoading from '../../../../common/SmallLoading/SmallLoading';
import {
  getBrandOfSelectedTicket,
  getSelectedTicketCustomerEmail,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../extractFromState';
import { getShopNameOfSelectedOrder } from '../../../../../selectors/tools';
import { handleError } from '../../../../../services/ErrorService/ErrorService';
import { fetchRbiChallengeInfo } from '../../../../../api/orders/rbi';
import { Container, HeaderContainer, SpinnerWrapper } from './DTRbiChallengeWidget.styles';
import DTSearchInput from '../../../Common/DTSearchInput/DTSearchInput';
import { validate as validateEmail } from 'email-validator';
import { displayPopupMessageInformation } from 'components/tools/SearchPage/searchUtils';
import { ChallengeTable } from 'components/DecisionTree/DTInfoWidget/RBI/DTRbiChallengeWidget/ChallengeTable';

const DTRbiChallengeWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [challenges, setChallenges] = useState([]);
  const [selectedChallengeId, setSelectedChallengeId] = useState(null);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const customerEmail = useSelector(getSelectedTicketCustomerEmail);
  const domain = useSelector(getShopNameOfSelectedOrder);
  const brandName = useSelector(getBrandOfSelectedTicket);

  const handleChangeSelectedChallengeId = (challengeId) => {
    setSelectedChallengeId(challengeId === selectedChallengeId ? null : challengeId);
  };

  const fetchChallengeInfo = useCallback(
    async (email) => {
      try {
        setIsLoading(true);
        const result = await fetchRbiChallengeInfo(simplrAccountId, domain, brandName, email);
        if (result?.challenges) {
          setChallenges(result.challenges);
        } else {
          setChallenges([]);
        }
      } catch (error) {
        handleError({ error, customMessage: 'Error fetching Challenge Info for this email', showPopup: true });
        setChallenges([]);
      } finally {
        setIsLoading(false);
      }
    },
    [simplrAccountId, domain, brandName]
  );

  const handleSearchSubmit = useCallback(
    async (value) => {
      if (!validateEmail(value)) {
        return displayPopupMessageInformation('Please enter a valid email address');
      }
      await fetchChallengeInfo(value);
    },
    [fetchChallengeInfo]
  );

  useEffect(() => {
    fetchChallengeInfo(customerEmail);
  }, [fetchChallengeInfo, customerEmail]);

  return (
    <>
      <Container>
        <HeaderContainer>
          <DTSearchInput
            placeholder="Search by customer email"
            messageImg={false}
            searchType={'RBI_CHALLENGE'}
            searchValue={customerEmail}
            defaultValue={customerEmail}
            onSearchSubmit={handleSearchSubmit}
          />
        </HeaderContainer>
        {isLoading ? (
          <SpinnerWrapper data-testid="notes-spinner-wrapper">
            <SmallLoading />
          </SpinnerWrapper>
        ) : (
          <>
            <ChallengeTable
              challenges={challenges}
              selectedChallengeId={selectedChallengeId}
              handleChangeSelectedChallengeId={handleChangeSelectedChallengeId}
            />
          </>
        )}
      </Container>
    </>
  );
};
export default DTRbiChallengeWidget;
